class OfferProduct extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector(".offer-product__checkbox");
    this.label = this.querySelector(".offer-product__label");
    this.clickHandler = this.handleClick.bind(this);
    this._onExternalChange = this._onExternalChange.bind(this);
  }

  connectedCallback() {
    if (!this.checkbox) return;

    this.defaultVariantId = this.checkbox.value || this.dataset.variantId || "";
    this.addEventListener("click", this.clickHandler);
    document.addEventListener("tradein:change", this._onExternalChange);
    document.addEventListener("care:change", this._onExternalChange);
    document.addEventListener("variant:change", this._onExternalChange);

    this.syncCheckboxValue();
    this.updateVisualState();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.clickHandler);
    document.removeEventListener("tradein:change", this._onExternalChange);
    document.removeEventListener("care:change", this._onExternalChange);
    document.removeEventListener("variant:change", this._onExternalChange);
  }

  handleClick(event) {
    if (!event.target.closest(".offer-product__label")) return;

    event.preventDefault();
    event.stopPropagation();

    this.checkbox.checked = !this.checkbox.checked;
    this.syncCheckboxValue();
    this.updateVisualState();
    this.updateTotalPrice();
    this.checkbox.dispatchEvent(new Event("change", { bubbles: true }));
  }

  syncCheckboxValue() {
    if (this.checkbox.checked) {
      this.checkbox.value = this.defaultVariantId;
      return;
    }

    this.checkbox.value = "";
    delete this.checkbox.dataset.discount;
  }

  updateVisualState() {
    this.classList.toggle("is-selected", this.checkbox.checked);
  }

  updateTotalPrice() {
    const salePriceEl = document.querySelector(".product-info__buy-buttons .buy-bottons_price price-list sale-price");
    const compareAtPriceEl = document.querySelector(
      ".product-info__buy-buttons .buy-bottons_price price-list compare-at-price",
    );
    const initialPriceEl = document.querySelector(".rating-with-text sale-price");
    const formatMoney = window.getFormattedMoney;
    if (!salePriceEl || !initialPriceEl || typeof formatMoney !== "function") return;

    // 主产品：销售价用 price，划线价用 compare_at（无则回退 price）
    const mainSale = Number(salePriceEl.dataset.price || initialPriceEl.dataset.price || 0);
    const mainCompare = Number(compareAtPriceEl?.dataset?.price || mainSale);

    const tradeInEl = document.querySelector('trade-in input[name="tradein-device"]');
    const careEl = document.querySelector('.care-variant[careActive="true"]');
    const tradeInPrice = tradeInEl ? Number(tradeInEl.dataset.devicePrice || 0) : 0;
    const carePrice = careEl ? Number(careEl.dataset.price || 0) : 0;

    const variantPrice = Number(this.dataset.variantPrice || 0);
    const offerPrice = Number(this.dataset.salePrice || variantPrice);
    const offerCompare = Number(this.dataset.comparePrice || variantPrice);
    const stackWithTradein = this.dataset.stackWithTradein === "true";
    const hasTradeIn = tradeInPrice > 0;
    // 不可叠加且已选以旧换新时：offer 按原价加购，不写折扣码
    const canApplyOfferDiscount = stackWithTradein || !hasTradeIn;
    const applyOfferDiscount = this.checkbox.checked && canApplyOfferDiscount;

    const cardSaleEl = this.querySelector(".offer-product__price--sale");
    const cardCompareEl = this.querySelector(".offer-product__price--compare");
    const cardDisplaySale = canApplyOfferDiscount ? offerPrice : variantPrice;
    const cardDisplayCompare = canApplyOfferDiscount ? offerCompare : Math.max(offerCompare, variantPrice);
    if (cardSaleEl) {
      cardSaleEl.replaceChildren(document.createRange().createContextualFragment(formatMoney(cardDisplaySale)));
    }
    if (cardCompareEl) {
      cardCompareEl.replaceChildren(document.createRange().createContextualFragment(formatMoney(cardDisplayCompare)));
      cardCompareEl.hidden = cardDisplayCompare <= cardDisplaySale;
    }

    // 销售价：主产品售价 − trade-in + care；划线价：主产品 compare_at + care（不减 trade-in）
    let totalSale = mainSale + carePrice - tradeInPrice;
    let totalOriginal = mainCompare + carePrice;

    if (this.checkbox.checked) {
      totalSale += applyOfferDiscount ? offerPrice : variantPrice;
      totalOriginal += applyOfferDiscount ? Math.max(offerCompare, offerPrice) : variantPrice;
      if (applyOfferDiscount && this.dataset.discount) {
        this.checkbox.dataset.discount = this.dataset.discount;
      } else {
        delete this.checkbox.dataset.discount;
      }
    } else {
      this.syncCheckboxValue();
    }

    const showCompare = totalSale !== totalOriginal;
    salePriceEl.lastChild?.replaceWith?.(document.createRange().createContextualFragment(formatMoney(totalSale)));

    if (compareAtPriceEl) {
      compareAtPriceEl.lastChild?.replaceWith?.(
        document.createRange().createContextualFragment(formatMoney(totalOriginal)),
      );
      compareAtPriceEl.toggleAttribute("hidden", !showCompare);
    }
  }

  _onExternalChange() {
    this.updateTotalPrice();
  }
}

if (!window.customElements.get("offer-product")) {
  window.customElements.define("offer-product", OfferProduct);
}
